export default function TermsContent() {
  return (
    <>
      <p className="text-text-muted">Last Updated: December 29, 2025</p>

      <p className="text-text-secondary">
        These Terms of Service ("Terms") govern your access to and use of the
        Vector Migration tool developed by AgileForce LTD, a company registered
        in the United Kingdom ("we", "us", "our").
      </p>

      <Section title="1. Definitions">
        <List items={["Service: Our online vector migration tool", "User: Anyone using the tool", "Account: Your registered profile"]} />
      </Section>

      <Section title="2. Eligibility">
        <List items={["Must be at least 16 years old", "Must have legal authority", "Must provide accurate information"]} />
      </Section>

      <Section title="3. Account Registration">
        <p className="text-text-secondary">
          You agree to secure your account, keep credentials confidential,
          and notify us of unauthorised activity.
        </p>
      </Section>

      <Section title="4. Use of the Service">
        <List items={["No illegal use", "No unauthorised access attempts", "No system disruption", "No reverse engineering or copying", "No malicious uploads"]} />
      </Section>

      <Section title="5. Data Migration Responsibilities">
        <p className="text-text-secondary">
          You are solely responsible for the data you migrate and must ensure
          legality, accuracy, and backups before migrations.
        </p>
      </Section>

      <Section title="6. Intellectual Property">
        <p className="text-text-secondary">
          All intellectual property belongs to AgileForce LTD. You receive
          a limited, non-transferable licence.
        </p>
      </Section>

      <Section title="7. Service Availability">
        <p className="text-text-secondary">
          We do not guarantee uninterrupted access due to maintenance,
          security, or technical issues.
        </p>
      </Section>

      <Section title="8. Fees and Payments">
        <p className="text-text-secondary">
          Fees apply only to paid plans. Payments are non-refundable unless
          required by law.
        </p>
      </Section>

      <Section title="9. Limitation of Liability">
        <p className="text-text-secondary">
          Liability is limited to fees paid in the last 12 months. We are not
          responsible for indirect or consequential damages.
        </p>
      </Section>

      <Section title="10. Governing Law">
        <p className="text-text-secondary">
          Governed by the laws of England and Wales. Courts of England and
          Wales have exclusive jurisdiction.
        </p>
      </Section>

      <Section title="Contact">
        <p className="text-text-secondary">
          AgileForce LTD <br />
          Email: admin@agileforce.co.uk
        </p>
      </Section>
    </>
  );
}

/* ---------- helpers ---------- */

function Section({ title, children }) {
  return (
    <div className="space-y-2">
      <h3 className="font-semibold text-text-primary">{title}</h3>
      {children}
    </div>
  );
}

function List({ items }) {
  return (
    <ul className="list-disc list-inside space-y-1 text-text-secondary">
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}